import { isHTTPError, HTTPError, isNetworkError, isTimeoutError } from 'ky'

export interface BaseErrorData {
  message?: string
  showMessage?: boolean
}

export function getErrorMessage(error: Error, defaultValue?: string) {
  if (isNetworkError(error)) {
    return 'Network error'
  }

  if (isTimeoutError(error)) {
    return 'Network timeout'
  }

  if (isHTTPError(error)) {
    const err = error as HTTPError<BaseErrorData>

    if (typeof err.data !== 'string' && err.data?.showMessage) {
      return err.data.message ?? defaultValue
    }
    return defaultValue
  }

  return defaultValue
}

export { isHTTPError, HTTPError, isNetworkError, isTimeoutError }
